module.exports = __webpack_public_path__ + "files/f1ff74d1e870516b4303fe50785a37df.png";